import React from 'react';
import { useNavigate } from 'react-router-dom';

const NotFound: React.FC = () => {
    const navigate = useNavigate();

    const handleGoBack = () => {
        if (window.history.length > 1) {
            navigate(-1);
        } else {
            navigate('/');
        }
    };

    return (
        <section className="flex flex-col items-center justify-center text-center px-6 sm:px-12 pt-24 sm:pt-32 pb-16 sm:pb-24 min-h-[calc(100vh-160px)]">
            {/* Illustration */}
            <img
                src="/error/Error_Landing_icon.png"
                alt=""
                aria-hidden="true"
                style={{
                    width: 'clamp(220px, 28vw, 439px)',
                    height: 'auto',
                    display: 'block',
                }}
            />

            {/* Heading */}
            <h1
                className="mt-8 sm:mt-12"
                style={{
                    fontFamily: 'Manrope',
                    fontWeight: 500,
                    fontSize: 'clamp(40px, 7vw, 128px)',
                    lineHeight: 1.1,
                    letterSpacing: '-0.05em',
                    color: '#FFFFFF',
                    maxWidth: 1294,
                }}
            >
                Oops! This page didn't make the match
            </h1>

            {/* Subtitle */}
            <p
                className="mt-6 sm:mt-8"
                style={{
                    fontFamily: 'Manrope',
                    fontWeight: 200,
                    fontSize: 'clamp(18px, 2.5vw, 45px)',
                    lineHeight: 1.35,
                    letterSpacing: '-0.05em',
                    color: '#FFFFFF',
                    maxWidth: 1369,
                }}
            >
                Looks like the opportunity you were searching for doesn't exist — but don't worry, we've got plenty of better ones waiting.
            </p>

            {/* Go back button */}
            <button
                onClick={handleGoBack}
                className="mt-10 sm:mt-12 inline-flex items-center justify-center transition-transform hover:scale-[1.02] active:scale-[0.98]"
                style={{
                    width: 180,
                    height: 53,
                    padding: '12px 30px',
                    gap: 8,
                    background:
                        'linear-gradient(180deg, rgba(61, 66, 68, 0) -40.91%, rgba(158, 170, 176, 0.248) 132.95%)',
                    boxShadow: 'inset 0px 8px 10px rgba(246, 249, 255, 0.08)',
                    filter: 'drop-shadow(0px 6px 40px rgba(255, 255, 255, 0.08))',
                    backdropFilter: 'blur(50px)',
                    borderRadius: 10,
                    border: 'none',
                    cursor: 'pointer',
                }}
            >
                <svg width="20" height="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M15 18L9 12L15 6" stroke="#C0C0BF" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
                </svg>
                <span
                    style={{
                        fontFamily: 'Manrope',
                        fontWeight: 500,
                        fontSize: 14,
                        lineHeight: '150%',
                        color: '#C0C0BF',
                    }}
                >
                    Go back
                </span>
            </button>
        </section>
    );
};

export default NotFound;
